module.exports = __webpack_public_path__ + "static/media/ke.dd8a91b8.svg";